import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Box } from '../box'

export type ChipGroupProps = {
    children: React.ReactNode
    className?: string
    testID?: string
}

/**
 * Horizontal wrapping container for chips (Figma ChipGroup, node 6987:4455).
 * Lays its children out in a row that wraps, with the standard 8px gap.
 */
export const ChipGroup: React.FC<ChipGroupProps> = ({ children, className, testID }) => (
    <Box className={twMerge('flex-row flex-wrap items-center gap-2', className)} testID={testID}>
        {children}
    </Box>
)

ChipGroup.displayName = 'ChipGroup'
